const navbarMenu = document.getElementById("menu");
const subMenu = document.getElementById("sub-navbar");
const burgerMenu = document.getElementById("burger");
const bgOverlay = document.getElementById("overlay");

// Show Menu when Click the Burger
// Hide Menu when Click the Overlay
if (burgerMenu && navbarMenu && bgOverlay && subMenu) {
    burgerMenu.addEventListener("click", () => {
        navbarMenu.classList.toggle("is-active");
        bgOverlay.classList.toggle("is-active");
        subMenu.classList.toggle("is-active");
    });

    bgOverlay.addEventListener("click", () => {
        navbarMenu.classList.toggle("is-active");
        bgOverlay.classList.toggle("is-active");
        subMenu.classList.toggle("is-active");
    });
}

// Hide Menu when Click the Links
document.querySelectorAll(".menu-link").forEach((link) => {
    link.addEventListener("click", () => {
        navbarMenu.classList.remove("is-active");
        bgOverlay.classList.remove("is-active");
        subMenu.classList.toggle("is-active");
    });
});

(function($) {
    class ResponsiveMenu {
        constructor() {
            this.initiateMenu();
        }

        initiateMenu() {
            var $body = $("body");
            var $menu1 = $('');

            if ($(window).width() < 1024) {
                $body.on('click', '.menu-item-has-children', function(e) {
                    var $this = $(this);
                    var $subMenu = $this.find(".sub-menu-wrap-0");
                    // Uncomment : If you want to hide submenu of an other element of menu
                    //$body.find('.menu-item-has-children .sub-menu-wrap-0').not(this).removeClass("open");

                    if ($subMenu.hasClass("open")) {
                        //$subMenu.removeClass("open");
                    } else {
                        $subMenu.addClass("open");
                    }
                });
            }
        } // initiateMenu()
    }

    new ResponsiveMenu();

})(jQuery);

document.getElementById('burger').addEventListener('click', function() {
    this.classList.toggle('is-open');
});

$(document).ready(function () {
    //Minify main nav
    if (window.matchMedia("(min-width: 1024px)").matches) {
        $(window).scroll(function () {
            $("#mainHeader").toggleClass("navbar-shrink", $(this).scrollTop() > 100)
        });
    }
});

// pour le niveau 3
document.addEventListener('DOMContentLoaded', function () {
    // Sélectionner tous les sous-menus de niveau 3 (ceux avec 'sub-menu-wrap-1')
    const menuItems = document.querySelectorAll('.menu-item-has-children .sub-menu-wrap-1');
    const menuParent = document.querySelectorAll('.menu-item-has-children .sub-menu-wrap-1');
    menuItems.forEach(function (menu) {
        // Récupérer l'élément parent (qui contient le lien de niveau 2)
        const parentItem = menu.parentElement;

        if (parentItem) {
            // Créer dynamiquement un bouton dropdown pour chaque parent de niveau 3
            const dropdownToggle = document.createElement('span');
            dropdownToggle.classList.add('dropdown-toggle');
            dropdownToggle.setAttribute('aria-expanded', 'false'); // Pour l'accessibilité

            // Insérer le bouton juste après le lien parent (niveau 2)
            const parentLink = parentItem.querySelector('a');

            if (parentLink) {
                parentLink.insertAdjacentElement('afterend', dropdownToggle); // Insérer après le lien

                // Gérer le clic sur le bouton dropdown pour ouvrir/fermer le sous-menu de niveau 3
                dropdownToggle.addEventListener('click', function () {
                    const isOpen = menu.classList.contains('open');

                    // Fermer tous les autres sous-menus de niveau 3
                    menuItems.forEach(function (subMenu) {
                        subMenu.classList.remove('open');
                        dropdownToggle.classList.remove('open-third');
                        subMenu.parentElement.querySelector('.dropdown-toggle').setAttribute('aria-expanded', 'false');
                    });

                    // Ouvrir/fermer le sous-menu actuel
                    if (!isOpen) {
                        menu.classList.add('open');
                        dropdownToggle.classList.add('open-third');
                        dropdownToggle.setAttribute('aria-expanded', 'true');
                        menuItem.classList.add('active'); // Ajouter la classe 'active' au premier niveau
                    }
                });
            }
        }
    });
});

// pour active le niveau 1
document.addEventListener('DOMContentLoaded', function () {
    // Sélectionner tous les éléments de premier niveau qui ont des enfants
    const firstLevelItems = document.querySelectorAll('.menu-item-has-children');

    firstLevelItems.forEach(function (item) {
        // Sélectionner le sous-menu associé
        const subMenu = item.querySelector('.sub-menu');

        if (subMenu) {
            // Gérer l'affichage du sous-menu au hover
            item.addEventListener('mouseenter', function () {
                item.classList.add('active'); // Ajouter la classe active au niveau 1
            });

            // Retirer la classe active lorsque la souris quitte le sous-menu
            item.addEventListener('mouseleave', function () {
                item.classList.remove('active'); // Retirer la classe active
            });
        }
    });
});

//spec mobile
document.addEventListener('DOMContentLoaded', function () {
    // Vérifier si on est sur mobile (par exemple, moins de 768px)
    if (window.innerWidth <= 768) {
        // Sélectionner uniquement les items de niveau 1 qui ont des enfants (sous-menus)
        const menuItems = document.querySelectorAll('#menu-primary > .menu-item-has-children');

        menuItems.forEach(function (menuItem) {
            // Récupérer le sous-menu associé
            const subMenu = menuItem.querySelector('.sub-menu');

            if (subMenu) {
                // Ajouter une classe spécifique pour le sous-menu de niveau 1
                subMenu.classList.add('sub-menu-level1');

                // Créer dynamiquement un bouton dropdown pour chaque élément de niveau 1
                const dropdownToggle = document.createElement('span');
                dropdownToggle.classList.add('dropdown-toggle-level1');  // Classe spécifique pour le niveau 1
                dropdownToggle.setAttribute('aria-expanded', 'false');  // Accessibilité

                // Insérer le bouton juste après le lien de niveau 1
                const parentLink = menuItem.querySelector('a');
                if (parentLink) {
                    parentLink.insertAdjacentElement('afterend', dropdownToggle); // Insérer le bouton après le lien

                    // Gérer le clic sur le bouton dropdown pour ouvrir/fermer le sous-menu
                    dropdownToggle.addEventListener('click', function () {
                        const isOpen = subMenu.classList.contains('open-level1');

                        // Fermer tous les autres sous-menus de niveau 1
                        menuItems.forEach(function (item) {
                            const otherSubMenu = item.querySelector('.sub-menu-level1');
                            const otherDropdown = item.querySelector('.dropdown-toggle-level1');
                            if (otherSubMenu && otherDropdown && otherSubMenu !== subMenu) {
                                otherSubMenu.classList.remove('open-level1');
                                otherDropdown.setAttribute('aria-expanded', 'false');
                            }
                        });

                        // Ouvrir/fermer le sous-menu actuel
                        if (!isOpen) {
                            subMenu.classList.add('open-level1');
                            dropdownToggle.setAttribute('aria-expanded', 'true');
                            dropdownToggle.classList.add('active');
                        } else {
                            subMenu.classList.remove('open-level1');
                            dropdownToggle.setAttribute('aria-expanded', 'false');
                            dropdownToggle.classList.remove('active');
                        }
                    });
                }
            }
        });
    }
});





// Toggle footer nav on mobile
window.addEventListener('DOMContentLoaded', () => {
    console.log('Made with ❤️ by Atalanta');

    const elsSousservice = document.querySelectorAll('.menu-parent')
    elsSousservice.forEach(sousservice => {
        sousservice.addEventListener('click', () => {
            const sousServiceChildList = sousservice.querySelector('.menu-parent .menu')

            if(sousServiceChildList.classList.contains('active')) {
                sousServiceChildList.classList.remove('active')
                sousservice.classList.remove('active')
            } else {
                if(document.querySelector('.row .menu.active')) {
                    document.querySelector('.row .menu.active').classList.remove('active')
                    document.querySelector('.menu-parent.active').classList.remove('active')
                }
                sousServiceChildList.classList.add('active')
                sousservice.classList.add('active')
            }

        })
    });

})
